"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioEpisodeSchema = void 0;
exports.AudioEpisodeSchema = {
    "$id": "https://www.redbull.com/schemas/content/audio-episodes.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "AudioEpisode",
    "description": "An episode of an audio series (either a podcast series or a radio show)",
    "properties": {
        "type": {
            "enum": [
                "rrn:content:audio-episodes"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:audio-episodes:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        },
        "attributes": {
            "additionalProperties": false,
            "type": "object",
            "properties": {
                "author": {
                    "type": "string",
                    "deprecated": true,
                    "deprecationReason": "This property will be removed from the abstract with the next release",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "callToActions": {
                    "type": "array",
                    "items": {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/call-to-action.schema.json"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "contentClassificationTerms": {
                    "description": "User defined terms to classify content.",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "contextualTitle": {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/contextual.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "customProperties": {
                    "description": "Custom properties which can be added to content-resources (E.g. configuration of theme properties, etc.) Note that custom properties are not governed by the content-schema. It is therefore not guaranteed that certain custom properties exist. We also do not migrate custom properties if the schema evolves.",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/key-value.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "geoBlockedIn": {
                    "description": "Countries in which the resource is geo-blocked. Resembled through two-letter ISO_3166-1_alpha-2 country codes",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "isPlaceholder": {
                    "description": "Marks a resource as placeholder.",
                    "type": "boolean",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "legacyContentId": {
                    "description": "RB2 content ID.",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "mainPartner": {
                    "description": "Represents the main partner associated with the resource",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/featured-partners.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "planningClassification": {
                    "description": "Content classification rating from the scheduling team.",
                    "type": "array",
                    "items": {
                        "type": "string",
                        "enum": [
                            "A",
                            "B",
                            "C",
                            "D",
                            "E"
                        ]
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "publishedDate": {
                    "description": "The initial published date of the resource. This date is set automatically if the resource is moved from `draft` to `published` state the first time.",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/date-time.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "searchTerms": {
                    "description": "A list of search terms which result in a full-match of a given content resource.",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "subHeading": {
                    "description": "An additional title of a resource. e.g. films often have subheadings like `Streif - One Hell of a Ride` where `One Hell of a Ride` would be the subHeading",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "teaser": {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                },
                "title": {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "uriSlug": {
                    "type": "string",
                    "description": "Must be unique across content GUID+language and may be reused for different locales"
                },
                "url": {
                    "description": "If provided, the URL should be used instead of dynamic routes (based on urislug) to link to the content resource (can be used to add resources which are presented outside the RB3 platform)",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/web-link.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "usageRestrictions": {
                    "description": "Restrictions describing where the specific resource should NOT be used.",
                    "type": "array",
                    "items": {
                        "type": "string",
                        "enum": [
                            "maturity:NR",
                            "maturity:UR",
                            "no-monetization",
                            "no-stand-alone-display"
                        ]
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "body": {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/paragraph-container.schema.json"
                },
                "episodeNumber": {
                    "type": "integer",
                    "description": "The episode number of this episode (e.g. `1`)"
                },
                "essence": {
                    "description": "Reference to audio source",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/type-groups/services/audio.schema.json"
                },
                "hosts": {
                    "description": "A list of persons who are hosting the episode",
                    "type": "array",
                    "items": {
                        "anyOf": [
                            {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                            },
                            {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/judges.schema.json"
                            },
                            {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/person-profiles.schema.json"
                            }
                        ]
                    }
                },
                "seasonNumber": {
                    "type": "integer",
                    "description": "The season number of this episode (e.g. `1`). This field is inherited from the season attached through the `season` relationship",
                    "calculated": true
                }
            },
            "required": [
                "title",
                "episodeNumber",
                "essence",
                "teaser",
                "uriSlug"
            ]
        },
        "relationships": {
            "additionalProperties": false,
            "type": "object",
            "properties": {
                "contentCollections": {
                    "type": "object",
                    "description": "Lists all content-collections that are automatically assigned through the tag tree. Collections are automatically assigned if the `autoAssign` attribute of the collection is set to `true` and one of the tags set on the content resource is also available on the content collection's `mappedTags` relationship.",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/collections.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "displayTags": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "deprecated": true,
                    "deprecationReason": "Display-tags are replaced with content-collections. Use relationship `contentCollections` instead. For further details check out http://bit.ly/2F9w93H",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/tags.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "embeddedResources": {
                    "type": "object",
                    "description": "All resources embedded in attributes",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "featuredMedia": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                                    },
                                    {
                                        "type": "object",
                                        "$ref": "https://www.redbull.com/schemas/reference/content/videos.schema.json"
                                    }
                                ]
                            },
                            "minItems": 1
                        }
                    }
                },
                "headerMedia": {
                    "type": "object",
                    "description": "Content piece shown in the header of another content element (e.g. image shown in the header of a story)",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "anyOf": [
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/episode-videos.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/films.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/recap-videos.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/trailer-videos.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/videos.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/video-channels.schema.json"
                                }
                            ]
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "locations": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/locations.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "logo": {
                    "type": "object",
                    "description": "Optional logo for a content piece (e.g. logo for an event-profile)",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "master": {
                    "type": "object",
                    "description": "Reference to the master resource holding all translations",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "partners": {
                    "type": "object",
                    "description": "Contains a list of additional partners or sponsors associated with the resource",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/partner-profiles.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "pseudoGroups": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/tags.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "relatedContents": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "socialMediaImage": {
                    "type": "object",
                    "description": "Image that represents a content resource on social media platforms (og:image)",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "tags": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "translatedFrom": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/localized/type-groups/content.schema.json"
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "translations": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/localized/type-groups/content.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "season": {
                    "type": "object",
                    "description": "The season the episode belongs to",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/content/audio-seasons.schema.json"
                        }
                    }
                },
                "transcript": {
                    "type": "object",
                    "description": "Transcript of the audio file",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/content/event-details.schema.json"
                        }
                    }
                }
            },
            "required": [
                "featuredMedia",
                "season"
            ]
        },
        "links": {
            "type": "object",
            "additionalProperties": {
                "type": [
                    "object",
                    "string"
                ],
                "description": "A link **MUST** be represented as either: a string containing the link's URL or a link object.",
                "oneOf": [
                    {
                        "description": "A string containing the link's URL.",
                        "type": "string",
                        "format": "uri-reference"
                    },
                    {
                        "type": "object",
                        "required": [
                            "href"
                        ],
                        "properties": {
                            "href": {
                                "description": "A string containing the link's URL.",
                                "type": "string",
                                "format": "uri-reference"
                            },
                            "meta": {
                                "description": "Non-standard meta-information that can not be represented as an attribute or relationship.",
                                "type": "object",
                                "additionalProperties": true
                            }
                        }
                    }
                ]
            }
        },
        "meta": {
            "additionalProperties": true,
            "type": "object",
            "properties": {
                "createdBy": {
                    "description": "User or system that initially created a resource",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "dateCreated": {
                    "description": "DateTime when a resource was created",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "dateUpdated": {
                    "description": "DateTime when a resource was last changed. Every change to a resource results in a new dateUpdated",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "externalReference": {
                    "description": "Reference to external applications (e.g. if the asset was imported)",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/external-reference.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "foreignKeys": {
                    "description": "Foreign keys of this asset in other systems (e.g. if the asset was imported / links to media asset system)",
                    "type": "array",
                    "deprecated": true,
                    "deprecationReason": "This property will be removed anytime soon. However, the information won't be lost but migrated to `externalReference`",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "language": {
                    "description": "The language the resource is written in",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "locale": {
                    "description": "The locale of the resource.",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "machineTranslated": {
                    "description": "Indicates if the asset was translated by machine/AI.",
                    "type": "boolean",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "published": {
                    "description": "Indicator if resource is published.",
                    "type": "boolean",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "region": {
                    "description": "The region or country the resource was published for (e.g. INT for international region, AT for Austria)",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "spaces": {
                    "description": "Content-spaces a resource is assigned to",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "status": {
                    "description": "Represents the current lifecycle state of the resource. The status can either be `DRAFT`, `PUBLISHED`, or `UNPUBLISHED`.",
                    "type": "string",
                    "enum": [
                        "DRAFT",
                        "PUBLISHED",
                        "UNPUBLISHED"
                    ],
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "updatedBy": {
                    "description": "User or system that updated the resource the last time",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                }
            }
        }
    },
    "type": "object",
    "required": [
        "type",
        "id",
        "attributes",
        "relationships"
    ]
};
//# sourceMappingURL=data:application/json;base64,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